module.exports = __webpack_public_path__ + "img/image-01.816fa776.jpeg";